<template>
    <div>
        <CardBase>
            <MacroSubHeader title="Distribuidores" icon="fas fa-users fa-1x"/>

            <div class="d-flex flex-column mt-3" style="gap: 20px">
                <DistribuidorFilter @filtered="handleFilters"/>
                <DistribuidorList ref="distribuidorList"/>
            </div>
        </CardBase>
    </div>
</template>

<script>
    // Components
    import {
        Table,
        TableColumn,
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Switch,
        Option,
        Select,
        Tag,
        Tooltip,
        Card,
        Empty,
        Notification,
        Descriptions,
        DescriptionsItem,
        Skeleton,
        Form,
        FormItem,
        Tabs, 
        TabPane,
    } from "element-ui";

    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";

    import DistribuidorIndicators from "../_internal/distribuidor/DistribuidorIndicators.vue";
    import DistribuidorFilter from "../_internal/distribuidor/DistribuidorFilter.vue";
    import DistribuidorList from "../_internal/distribuidor/DistribuidorList.vue";

    // Api
    import { DistribuidorApi } from "@/api/DistribuidorApi.js";
    const distribuidorApi = new DistribuidorApi();

    export default {
        name: "distribuidor",
        props: [],
        data() {
            return {
                data: [],
                dataHeader: null,
                activeTab: 'all',
                loading: false,
            }
        },
        computed: {
            getDataHeader() {
               return {
                    "Codigo": "codigo",
                    "Nome": "nome",
                    "Classe": "classe",
                    "Cidade":"cidade",
                    "Estado": "uf",
                    "Status": "status",
                    "Criado em": "created_at",
                    "Última atualização": "updated_at"
                }
            },
            generateNameFile() {
                const date = new Date();

                const formatted =
                    String(date.getDate()).padStart(2, '0') + '-' +
                    String(date.getMonth() + 1).padStart(2, '0') + '-' +
                    date.getFullYear();

                return `distribuidores-${formatted}`
            },  
        },
        methods: {

            handleFilters(filters) {
                this.$refs.distribuidorList.filters = filters;
            },
            async handleDispatch() {
                await this.$refs.distribuidorList.fetch();
            },
        },
        components: {
            MacroSubHeader,
            CardBase,
            [Message.name]: Message,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.name]: Dialog,
            [Button.name]: Button,
            [Switch.name]: Switch,
            [Option.name]: Option,
            [Select.name]: Select,
            [Input.name]: Input,
            [Tooltip.name]: Tooltip,
            [Tag.name]: Tag,
            [Card.name]: Card,
            [Empty.name]: Empty,
            [Notification.name]: Notification,
            [Descriptions.name]: Descriptions,
            [DescriptionsItem.name]: DescriptionsItem,
            [Skeleton.name]: Skeleton,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            DistribuidorIndicators,
            DistribuidorFilter,
            DistribuidorList
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Index.vue